var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"summary-container"},[_vm._l((_vm.typeData),function(ts,index){return [(index > 0)?_c('div',{key:index,staticClass:"summary-item"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(ts.value))]),_c('span',{staticClass:"value publication"},[_vm._v(_vm._s(ts.total))])]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }